import { hasParentWithSelector } from '@mm/utils/src/dom-utils';
import classnames from 'classnames';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import './ThreeDotMenu.scss';

export type ThreeDotMenuItem = {
  className?: string;
  name: string;
  value: string;
  disabled?: boolean;
  children?: React.ReactNode;
  hideName?: boolean;
};
export type ThreeDotMenuProps = {
  className?: string;
  contentClassName?: string;
  onClick?: (e: React.MouseEvent) => void;
  elements: ThreeDotMenuItem[];
  anchor?: ReactNode;
  selectItem: (value: string) => void;
  children?: string | ReactNode | Element[];
  dotColor?: string;
};

export const ThreeDotMenu = ({
  className,
  onClick,
  elements,
  anchor,
  children,
  selectItem,
  contentClassName,
  dotColor = '#b6a8a8',
}: ThreeDotMenuProps) => {
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  const ref = useRef<HTMLInputElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    const { target } = event;
    if (
      ref &&
      target instanceof Node &&
      ref.current &&
      !ref.current.contains(target)
    ) {
      if (
        !hasParentWithSelector(
          event.target as any,
          '.react-tiny-popover-container',
        )
      ) {
        setIsComponentVisible(!isComponentVisible);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const showDropdown = (e: React.MouseEvent) => {
    setIsComponentVisible(true);
    if (onClick) onClick(e);
  };

  const onItemSelected = (value: string) => {
    selectItem(value);
    setIsComponentVisible(false);
  };

  return (
    <div
      className={classnames(className, 'three-dot-menu__dropdown')}
      style={{ '--three-dot-menu__dot-color': dotColor } as any}
      onClick={showDropdown}
    >
      {anchor || (
        <div className="three-dot-menu__icons three-dot-menu__btn-right" />
      )}
      {isComponentVisible && (
        <div
          className={classnames(
            contentClassName,
            'three-dot-menu__dropdown-content',
          )}
          ref={ref}
        >
          {elements.map(element => (
            <div
              className={classnames(
                element.className,
                'three-dot-menu__drop-down_list-item',
                {
                  'three-dot-menu__disabled': element.disabled,
                },
              )}
              key={element.name}
              onClick={e => {
                e.stopPropagation();
                if (!element.disabled) {
                  onItemSelected(element.value);
                }
              }}
            >
              <div className="three-dot-menu__drop-down_list-item-content">
                {!element.hideName && element.name}
                {element.children}
              </div>
            </div>
          ))}
          {children}
        </div>
      )}
    </div>
  );
};
